import * as React from 'react';

import './ProductCardLoading.scss';

function ProductCardLoading() {
  return (
    <div className="rp-product-card-loading">
      <div className="rp-product-card-loading--image" />
      <div className="rp-product-card-loading--buttons">
        <div className="buttons-placeholder">
          <span className="loading-bar buttons" />
          <span className="loading-bar buttons" />
        </div>
      </div>
      <div className="rp-product-card-loading--data">
        <span className="loading-bar short" />
      </div>
      <div className="rp-product-card-loading--buttons">
        <div className="buttons-placeholder">
          <span className="loading-bar buttons" />
          <span className="loading-bar buttons" />
        </div>
      </div>
      <div className="rp-product-card-loading--buttons">
        <div className="buttons-placeholder">
          <span className="loading-bar buttons" />
          <span className="loading-bar buttons" />
        </div>
      </div>
    </div>
  );
}

export default ProductCardLoading;
